export default "__VITE_ASSET__C_Ukrqg1__"